import "moment-timezone";
import ReactDOM from "react-dom";
import "utils/extendsFunctions";
import reportWebVitals from "./reportWebVitals";

// CSS imports

// First, import 3rd party library styles
import "bootstrap/dist/css/bootstrap.min.css";

// Next, import index.css for the base styles
import "./index.css";

// Then, import page-specific styles
import "./assets/css/dashboard.css";
import "./assets/css/gateway.css";
import "./assets/css/responsive.css";

// Then, import App which also imports other styles
import App from "./App";

// End of CSS imports

const root = document.getElementById("root");
const nonce = root?.getAttribute("data-nonce") ?? "";
ReactDOM.render(<App nonce={nonce} />, root);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
